import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ROUTES } from './lib/classroomRoutes';
import LandingPage from './pages/LandingPage';
import RegisterSelect from './pages/RegisterSelect';
import RegisterPrivate from './pages/RegisterPrivate';
import RegisterOrg from './pages/RegisterOrg';
import PortalLogin from './pages/PortalLogin';
import Introduction from './pages/Introduction';
import ProSetup from './pages/ProSetup';
import Workspace from './pages/Workspace';
import OrgAdmin from './pages/OrgAdmin';
import MasterAdminConsole from './pages/MasterAdminConsole';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path={ROUTES.LANDING} element={<LandingPage />} />

          <Route path={ROUTES.REGISTRATION_PATHWAY} element={<RegisterSelect />} />
          <Route path={ROUTES.REGISTRATION_PRIVATE} element={<RegisterPrivate />} />
          <Route path={ROUTES.REGISTRATION_ORGANISATION} element={<RegisterOrg />} />

          <Route path={ROUTES.CLASSROOM_PORTAL} element={<PortalLogin />} />
          <Route path="/Classroom-elt" element={<Navigate to={ROUTES.CLASSROOM_PORTAL} replace />} />
          <Route path={ROUTES.EXECUTIVE_INTRO} element={<Introduction />} />
          <Route path={ROUTES.STUDENT_SETUP} element={<ProSetup />} />
          <Route path={ROUTES.LEARNING_ROOM} element={<Workspace />} />
          <Route path={ROUTES.SYSTEM_ADMIN} element={<OrgAdmin />} />
          <Route path={`${ROUTES.MASTER_ADMIN}/*`} element={<MasterAdminConsole />} />

          {/* Bookmark route aliases */}
          <Route path="/register-select" element={<Navigate to={ROUTES.REGISTRATION_PATHWAY} replace />} />
          <Route path="/register-private" element={<Navigate to={ROUTES.REGISTRATION_PRIVATE} replace />} />
          <Route path="/register-org" element={<Navigate to={ROUTES.REGISTRATION_ORGANISATION} replace />} />
          <Route path="/portal-login" element={<Navigate to={ROUTES.CLASSROOM_PORTAL} replace />} />
          <Route path="/introduction" element={<Navigate to={ROUTES.EXECUTIVE_INTRO} replace />} />
          <Route path="/pro-setup" element={<Navigate to={ROUTES.STUDENT_SETUP} replace />} />
          <Route path="/workspace" element={<Navigate to={ROUTES.LEARNING_ROOM} replace />} />
          <Route path="/org-admin" element={<Navigate to={ROUTES.SYSTEM_ADMIN} replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
